import React, { Suspense } from 'react';
import { 
  Route, 
  Routes,
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements
} from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Lazy load all pages
const Home = React.lazy(() => import('./pages/Home'));
const Research = React.lazy(() => import('./pages/Research'));
const Team = React.lazy(() => import('./pages/Team'));
const Publications = React.lazy(() => import('./pages/Publications'));
const JoinUs = React.lazy(() => import('./pages/JoinUs'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Collaborators = React.lazy(() => import('./pages/Collaborators'));

// Loading component with skeleton UI
const PageLoader = () => (
  <div className="animate-pulse">
    <div className="h-48 bg-gray-200 rounded-lg mb-4"></div>
    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-200 rounded w-1/2"></div>
  </div>
);

const AppLayout = () => (
  <div className="flex flex-col min-h-screen">
    <Navigation />
    <main className="flex-grow">
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/research" element={<Research />} />
          <Route path="/team" element={<Team />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/collaborators" element={<Collaborators />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </main>
    <Footer />
  </div>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="*" element={<AppLayout />} />
  ),
  {
    future: {
      v7_relativeSplatPath: true
    }
  }
);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
